import { useQuery } from '@tanstack/react-query'
import { currencyServices } from '../currencyServices'
import { CurrencyCatalogsParams } from '../currencyTypes'

// Query key for caching
const QUERY_KEY_CURRENCIES = 'currencies'

interface QueryOptions {
  enabled?: boolean
}

export const useGetCurrenciesCatalogs = (
  params: CurrencyCatalogsParams,
  queryOptions?: QueryOptions,
) => {
  return useQuery({
    queryKey: [QUERY_KEY_CURRENCIES, params],
    queryFn: () => {
      return currencyServices.getCurrencies(params)
    },
    staleTime: 5 * 60 * 1000, // 5 minutes cache
    enabled: queryOptions?.enabled !== false,
    onSuccess: (data) => {},
    onError: (error) => {},
  })
}
